"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterNullAdmissionsFromOrderDetailFee = void 0;
var order_detail_types_1 = require("../../types/order-detail.types");
var filterNullAdmissionsFromOrderDetailFee = function (fees) {
    var authorizedNullFees = [order_detail_types_1.FEE_TYPE.ENTRANCE, order_detail_types_1.FEE_TYPE.ADMISSION_FEE, order_detail_types_1.FEE_TYPE.ROYALTY_FEE];
    return fees.filter(function (fee) { return (authorizedNullFees.includes(fee.type) ? fee.value === 0 || fee.value : !!fee.value); });
};
exports.filterNullAdmissionsFromOrderDetailFee = filterNullAdmissionsFromOrderDetailFee;
